import React, { memo, useEffect, useState } from "react";
import { connect } from "react-redux";
import { Checkbox, Button } from "antd";
import s from "./index.module.less";
import {LlwAiShortcuts} from "@/utils/sensorsFunc";
import webAppIcon from '@/assets/images/webapp_icon.png'

const AppInstallPrompt = (props) => {
  const { updateAppInstallPromptVisible } = props;
  const [notOpenIn7Days, setNotOpenIn7Days] = useState(false);

  let _appInstallPromptConfig = {};
  const setInstallPromptConfig = () => {
    let appInstallPromptConfig = localStorage.getItem('appInstallPromptConfig');
    appInstallPromptConfig = appInstallPromptConfig ? JSON.parse(appInstallPromptConfig) : {notOpenIn7Days: false};
    setNotOpenIn7Days(appInstallPromptConfig.notOpenIn7Days);
    _appInstallPromptConfig = {
      lastOpenTimestamp: Date.now(), // 最近一次打开时间，用来判断今天是否已打开
      notOpenIn7Days: appInstallPromptConfig.notOpenIn7Days, // 7天内是否再打开
      timestamp: Date.now() // 当前时间戳
    };
    localStorage.setItem('appInstallPromptConfig', JSON.stringify(_appInstallPromptConfig));
  };

  useEffect(() => {
    setInstallPromptConfig();
  }, []);

  const onCheckBoxChange = (e) => {
    let appInstallPromptConfig = localStorage.getItem('appInstallPromptConfig');
    appInstallPromptConfig = appInstallPromptConfig ? JSON.parse(appInstallPromptConfig) : {};
    appInstallPromptConfig.notOpenIn7Days = e.target.checked;
    appInstallPromptConfig.timestamp = Date.now();
    localStorage.setItem('appInstallPromptConfig', JSON.stringify(appInstallPromptConfig));
    setNotOpenIn7Days(e.target.checked);
  };

  const installWebApp = () => {
    LlwAiShortcuts({
      shortcuts: '3',
      if_7days_choose: notOpenIn7Days
    });
    const deferredPrompt = window.deferredPrompt;
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          window.deferredPrompt = null;
          LlwAiShortcuts({
            shortcuts: '4',
            if_7days_choose: notOpenIn7Days
          });
          updateAppInstallPromptVisible(false);
        }
      })
    }
  };

  return (
    <div className={s.installPromptWrap}>
      <div className={s.installPromptInner}>
        <div className={s.installPromptClose} onClick={() => {
          LlwAiShortcuts({
            shortcuts: '2',
            if_7days_choose: notOpenIn7Days
          });
          updateAppInstallPromptVisible(false);
        }}></div>
        <div className={s.installPromptContent}>
          <img src={webAppIcon} />
          <div className={s.title}>将溜溜AI保存到桌面，绘画、改图更方便哦~</div>
        </div>
        <div className={s.installPromptFooter}>
          <Checkbox onChange={onCheckBoxChange} checked={notOpenIn7Days}><span className={s.checkboxText}>最近不再弹出</span></Checkbox>
          <Button className={s.appInstallBtn} type="primary" onClick={() => installWebApp()}>保存到桌面</Button>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ app }) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateAppInstallPromptVisible: (params) => {
      return dispatch({
        type: "app/updateAppInstallPromptVisible",
        payload: params
      });
    }   
  };
};

export default memo(connect(mapStateToProps, mapDispatchToProps)(AppInstallPrompt));